// Port of api/fuel/app/classes/insights/hindex/init.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import HindexType from 'offline/model/hindex/type'
import HindexTrack from 'offline/model/hindex/track'
import Config from 'offline/model/config'
import Session from 'offline/stream/session'

export default Segment.extend({
    name: 'init',
    priority: 10,
    default_: true,
    requires: [],
    insight: [],
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        this._data.type = HindexType.record({
            where: {
                hindex_slug: (vars.index) ? vars.index : 'h-index'
            }
        })

        if (!this._data.type) return {}

        this._data.track = HindexTrack.record({
            where: {
                hindex_id: this._data.type.get_id(),
                user_id: owner.get_id()
            }
        })

        if (!this._data.track) return {}

        // Skip Sync\Type\User\Hindex::run() in offline mode — data should already be generated

        this._data.current = false

        if (this._data.track.get_hindex()) {

            this._data.current = Util.query(
                'SELECT * FROM log_user_hindex WHERE hindex_id = ' + this._data.type.get_id() +
                ' AND user_id = ' + owner.get_id() +
                ' ORDER BY log_hindex DESC LIMIT 1'
            )

            if (this._data.current.length) {
                var row = this._data.current[0]
                this._data.current = {
                    get_id: function() { return row.log_id },
                    get_hindex: function() { return parseInt(row.log_hindex, 10) },
                    get_date: function() { return parseInt(row.log_date, 10) },
                    get_days: function() { return parseInt(row.log_days, 10) },
                    get_plays_level: function() { return parseInt(row.log_plays_level, 10) },
                    get_plays_all: function() { return parseInt(row.log_plays_all, 10) },
                    get_games_level: function() { return parseInt(row.log_games_level, 10) },
                    get_games_new: function() { return parseInt(row.log_games_new, 10) },
                    get_games_all: function() { return parseInt(row.log_games_all, 10) },
                    get_efficiency_current: function() { return parseInt(row.log_efficiency_current, 10) },
                    get_efficiency_next: function() { return parseInt(row.log_efficiency_next, 10) },
                    get_game_id: function() { return parseInt(row.game_id, 10) },
                    get_index_level: function() {
                        return Util.parse_id_list(row.log_index_level)
                    },
                    get_index_played: function() {
                        return Util.parse_id_list(row.log_index_played)
                    }
                }
            } else {
                this._data.current = false
            }

        }

        this._data.filter = ''
        this._data.playFilter = ''

        var config = Config.user(owner.get_id())

        if (config.insights && config.insights.hindex && config.insights.hindex.exclude && config.insights.hindex.exclude.length) {

            this._data.filter = ' AND g.game_id NOT IN (' + Util.in(config.insights.hindex.exclude) + ')'
            this._data.playFilter = ' AND p.game_id NOT IN (' + Util.in(config.insights.hindex.exclude) + ')'

        }

        if (this._data.type.get_id() > 1) {

            // For custom h-index types, apply their filter to get applicable games
            var hindexFilter = this._data.type.get_filter()
            if (hindexFilter) {
                // In offline mode, we use a simplified approach: query games matching the filter
                // The full Filter::search is complex; for custom indexes we use the stored game index
                var gameIndex = Util.query(
                    'SELECT DISTINCT p.game_id AS g FROM play p, game g WHERE p.user_id IN(' + Util.in(userIndex) + ') AND p.game_id = g.game_id AND g.game_type = 1',
                    'g'
                )
                var gameIds = Object.keys(gameIndex).map(function(k) { return parseInt(k, 10) })
                if (!gameIds.length) gameIds = [0]

                this._data.filter += ' AND g.game_id IN(' + Util.in(gameIds) + ')'
            }

        }

        var tags = []
        if (owner.get_id() === Session.get('app.login')) {
            tags = Util.query('SELECT * FROM tag WHERE user_id = ' + owner.get_id())
        }

        return {
            public: parseInt(this._data.type.get_public(), 10),
            tags: tags
        }

    }
})
